import HeroText from "@/components/HeroText";
import Container from "@/components/Container";

interface IntroductionProps {
  onNext: () => void;
}

const Introduction = ({ onNext }: IntroductionProps) => {
  return (
    <>
      <Container className="lg:lc-mt-20">
        <HeroText
          heading="Navigate your next steps in finance"
          copy={`<p>There's a lot to unpack in the financial world. <br /> By answering
          just a few questions about your experience, ambition and interests
          we'll help you find the right next step.</p>`}
          buttonText="Start"
          buttonLink={onNext}
          smallText="Takes 2 minutes"
        />
        <div className="lc-bg-intro-background lc-bg-contain lc-bg-clip-content lc-bg-no-repeat lc-bg-bottom lc-w-full lc-h-full lc-absolute lc-bottom-0 lc-top-0 lc-left-0 lc-z-0"></div>
      </Container>
    </>
  );
};

export default Introduction;
